import PayFixedIncentiveBonus from '@/api/hr/pay-fixed-incentive-bonus'
import Employee from '@/api/hr/employee'
import IncentiveBonusItem from '@/api/hr/pay-item-incentive-bonus'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  employees: [],
  incentiveBonuses: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,

  RECEIVE_EMPLOYEES(state, employees) {
    state.employees = employees
  },

  RECEIVE_INCENTIVE_BONUSES(state, incentiveBonuses) {
    state.incentiveBonuses = incentiveBonuses
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        ...context.state.queryBuilder
      },
      attributes
    )

    context.commit('SET_QUERY_BUILDER', attributes)

    return PayFixedIncentiveBonus.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return PayFixedIncentiveBonus.store(data)
  },

  update(context, { id, ...data }) {
    return PayFixedIncentiveBonus.update(id, data)
  },

  destroy(context, id) {
    return PayFixedIncentiveBonus.destroy(id).then(response => {
      let resource = context.state.resources.find(r => r.record_id == id)

      if (resource) {
        context.state.resources.splice(context.state.resources.indexOf(resource), 1)
      }

      return response
    })
  },

  fetchEmployees(context, attributes = {}) {
    let params = {
      page: -1,
      fields: {
        hris_employee_profiles: 'employee_id,employee_name_en'
      },
      ...attributes
    }

    return Employee.get({ params }).then(response => {
      context.commit('RECEIVE_EMPLOYEES', response.data)
      return Promise.resolve(response)
    })
  },

  fetchIncentiveBonuses(context, attributes = {}) {
    let params = {
      page: -1,
      fields: {
        pay_item_deduction: 'inc_bonus_id,inc_bonus_item'
      },
      ...attributes
    }

    return IncentiveBonusItem.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params
    }).then(response => {
      context.commit('RECEIVE_INCENTIVE_BONUSES', response.data)
      return Promise.resolve(response)
    })
  }
}
